import { activeSiteConfig } from "@config/site/site-config";
import type { PaymentIcon } from "../types";
import { getLocalPaymentIconUrl } from "./localPaymentIcons";

export const getExternalProviderIcons = ({
    preferLocalIcons = false,
}: { preferLocalIcons?: boolean } = {}) => {
    const icons: PaymentIcon[] = [];

    if (activeSiteConfig.amazonPay?.enabled) {
        icons.push({
            type: "amazonPay",
            // Amazon Pay predates the design's icon set and keeps its own asset elsewhere, so
            // v2 takes the new one where it exists and everyone else stays on the old file.
            url:
                (preferLocalIcons ? getLocalPaymentIconUrl("amazonPay") : undefined) ??
                "/assets/icons/amazonpay-logo.svg",
            name: "Amazon Pay",
        });
    }

    return icons;
};
